import { Common } from '@stockbit/ui';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors as profileSelector } from 'lib/entities/profile';
import CheckBox from './Checkbox';
import PollingPinnedLabel from './PollingPinnedLabel';
import RenderSelectList from './RenderSelectList';
import {
  ButtonConfirm,
  PollingFooterContainer,
  PollingTimeContent,
  PollingTimeLabel,
  ReverseFlex,
} from './styled';

const { Text } = Common;

interface PollingFooterProps {
  onChangeDuration: (val: any) => any;
  onPin: (val: any) => any;
  isPinned: boolean;
  duration: any;
}

function PollingFooter({
  onChangeDuration,
  onPin,
  isPinned,
  duration,
}: PollingFooterProps) {
  const { data: dataProfile } = useSelector(profileSelector);

  const [isPollingContentVisible, setPollingContentVisibility] =
    useState(false);
  const [isChecked, setCheckBox] = useState(false);
  const [isSelectDisable, setDisableSelect] = useState(false);

  const handleChangeDuration = (data, isUnlimited = false) => {
    const val = {
      data,
      isUnlimited,
    };
    onChangeDuration(val);
  };

  useEffect(() => {
    // initiate polling end on mount
    handleChangeDuration({});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePinPolling = () => {
    onPin({ polling_pin: isPinned ? 0 : 1 });
  };

  const setPollingLabelTime = () => {
    const filteredSelect = Object.keys(duration).filter((e) => duration[e] > 0);
    if (!filteredSelect[0]) {
      return 'No end date';
    }
    return filteredSelect.reduce((acc, cur) => {
      let label = acc;
      label += `${duration[cur]} ${cur} `;
      return label;
    }, '');
  };

  return (
    <PollingFooterContainer>
      <ReverseFlex>
        <PollingTimeLabel>
          Poll length :{' '}
          <Text as="span" onClick={() => setPollingContentVisibility(true)}>
            {!isPollingContentVisible && setPollingLabelTime()}
          </Text>
        </PollingTimeLabel>
        {isPollingContentVisible && (
          <PollingTimeContent>
            <ReverseFlex>
              <RenderSelectList
                isSelectDisable={isSelectDisable}
                selectValue={duration}
                setSelectValue={handleChangeDuration}
              />
              <ButtonConfirm onClick={() => setPollingContentVisibility(false)}>
                OK
              </ButtonConfirm>
            </ReverseFlex>
            <CheckBox
              label="No end Date"
              checked={isChecked}
              onChange={() => {
                setCheckBox(!isChecked);
                setDisableSelect(!isSelectDisable);
                handleChangeDuration(
                  {
                    Days: !isSelectDisable ? 0 : 1,
                    Hours: 0,
                    Mins: 0,
                  },
                  !isChecked,
                );
              }}
            />
          </PollingTimeContent>
        )}
      </ReverseFlex>
      {!isPollingContentVisible && (parseInt(dataProfile.user_priv, 10) === 1) && (
        <PollingPinnedLabel
          onClick={handleChangePinPolling}
          isActive={isPinned}
        >
          Pin this polling
        </PollingPinnedLabel>
      )}
    </PollingFooterContainer>
  );
}

export default PollingFooter;
